export default __webpack_public_path__ + "static/guide-cta-ee8de5f536bf6c0e53951d656d4a0ab6.png";